export default "__VITE_ASSET__DnA1QZkT__"